import styles from "./SharePatientWebsite.module.css"
import CopyText from "@components/Common/CopyText"

const SharePatientWebsite = () => {
  return (
    <>
      <div className={styles.moreAppsCardWrapper}>
        <div className={styles.content}>
          <div className={styles.headerWrapper}>
            <h3 className={styles.heading}>COPY AND SHARE WEBSITE</h3>
          </div>
          <div className={styles.description}>
              https://patient.orbsway.com
            <CopyText textToBeCopied="https://patient.orbsway.com" />
          </div>
        </div>
      </div>
    </>
  )
}

export default SharePatientWebsite
